import type { ReactNode } from "react";
import { Container, Grid, Skeleton } from "@mui/material";
import CommandeCardSkeleton from "components/molecules/cards/CommandeCard/CommandeCardSkeleton";
import PageTitleSkeleton from "components/molecules/PageTitleSkeleton";
import { rangeUtil } from "utils/rangeUtil";

function FilterCommandesPageSkeleton(): ReactNode {
  return (
    <>
      <PageTitleSkeleton />
      <Container maxWidth="xl">
        <Grid container spacing={2} size={12} sx={{ alignItems: "center" }}>
          <Grid container spacing={2} size={12}>
            <Grid size={12}>
              <Skeleton animation="wave" width={150} height={50} />
            </Grid>
            <Grid size={12}>
              <Skeleton animation="wave" width={200} />
            </Grid>
          </Grid>

          <Grid container spacing={4} size={12}>
            {rangeUtil.arrayRange(6).map((i) => (
              <Grid key={i} size={{ xs: 12, lg: 6 }}>
                <CommandeCardSkeleton />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default FilterCommandesPageSkeleton;
